import axios from "axios";

// Mirrors the endpoint resolution used in Redux/AdminReducer/action.js
const getEndpoint = () =>
  window.location.protocol === "http:"
    ? "http://localhost:5001"
    : `https://${window.location.host}/api`;

const authHeaders = () => {
  try {
    const userData = JSON.parse(sessionStorage.getItem("clinic-application-jwt"));
    return userData?.token ? { Authorization: `Bearer ${userData.token}` } : {};
  } catch (e) {
    return {};
  }
};

/** Staff: fetch (creating if needed) the video room for an appointment. */
export const fetchSessionByAppointment = async (appointmentId) => {
  const { data } = await axios.get(
    `${getEndpoint()}/video-consultation/appointment/${appointmentId}`,
    { headers: authHeaders() }
  );
  return data;
};

/** Staff: list video consultations. */
export const fetchSessions = async (params = {}) => {
  const { data } = await axios.get(`${getEndpoint()}/video-consultation`, {
    headers: authHeaders(),
    params,
  });
  return data;
};

/** Staff: record that the clinician entered the room. */
export const markHostJoined = async (hostToken, payload = {}) => {
  const { data } = await axios.post(
    `${getEndpoint()}/video-consultation/host/${hostToken}/join`,
    payload,
    { headers: authHeaders() }
  );
  return data;
};

/** Staff: close the consultation. */
export const endSession = async (sessionId, payload = {}) => {
  const { data } = await axios.post(
    `${getEndpoint()}/video-consultation/${sessionId}/end`,
    payload,
    { headers: authHeaders() }
  );
  return data;
};

/** Staff: email the join link to the patient. */
export const sendInvite = async (sessionId, payload = {}) => {
  const { data } = await axios.post(
    `${getEndpoint()}/video-consultation/${sessionId}/invite`,
    { origin: window.location.origin, ...payload },
    { headers: authHeaders() }
  );
  return data;
};

/** Patient: look up the consultation behind a guest link (no login). */
export const fetchGuestSession = async (guestToken) => {
  const { data } = await axios.get(
    `${getEndpoint()}/video-consultation/public/${guestToken}`
  );
  return data;
};

/** Patient: record entry into the room. */
export const markGuestJoined = async (guestToken) => {
  const { data } = await axios.post(
    `${getEndpoint()}/video-consultation/public/${guestToken}/join`,
    {}
  );
  return data;
};

/** The link handed to the patient. */
export const buildPatientLink = (guestToken) =>
  `${window.location.origin}/public/consult/${guestToken}`;
